// tutorial: l'event bus è un helper per dispatchare eventi globali. In questa cartella possiamo aggiungere
// i listener per gli eventi dispatchati dall'applicazione nei moduli Vuex o nei componenti Vue
// vedi ad esempio "this.$eventBus.$emit(initEvent, initPayload);" nel componente di root App.vue
import Vue from 'vue';

export const bus = new Vue();

export const EventBusPlugin = {
    install(vm: any) {
        vm.prototype.$eventBus = bus;
    },
};
